import React ,{ useState } from "react";
import { ArrowRight,ThreeDotsVertical } from 'react-bootstrap-icons';
import { FaDownload,FaGithub,FaLinkedin,FaEnvelope,FaPhone,FaWhatsapp,FaBars,FaHamburger } from "react-icons/fa";

function Headerstory(props) {
  const [style, setStyle] = useState("none");






  let audio = new Audio("/click2.wav")
  let stop = true;
  
 
  const start = () => {
   
      // stop? audio.play():stop = false;   // must chheck!!!!!!!!!!1
      // stop = false
      audio.play()
  }
  const clickburger = ()=>{

  setStyle(style === "block" ? "none" : "block");
    console.log(style)
  }

  return (
    <div className="" >
       
      <div onClick={clickburger} className="  burger d-md-none display-6 text-center pt-4 " id="burgerid">
      <FaHamburger  />
      </div >
      <div id="id_header" className=" d-flex justify-content-around container ">
        <div id="id_logo" className="ml-5">
          <a href="#">
            {" "}
            <img src="yizlogo.png" height="150"  />
          </a>
        </div>
      
        <nav  className="nav_mob text-center d-md-none" id="nav_mo"  style={{ display: style }}
>
          <a href="#">Home</a>
          <a href="#helloid">story</a>
          <a href="#workid"
          >Works</a>
          <a href="#contactid">Contact</a>
          <a></a>
        </nav>
     
        <div className="nav_bar">
          <nav className="d-flex justify-content-end p-4 container  ">
            <div className="p-4" onMouseOver={start}>
              <a href="#"> Home</a>
            </div>
            <div className="p-4 link" onMouseOver={start}>
              <a href="#helloid"> story</a>
              <ThreeDotsVertical className="pb-1" />
              <div className="pop_up p-2 ">
                <a href="#skillid">skils</a>
              </div>
            </div>
            <div className="p-4  " onMouseOver={start}>
              <a href="#workid"> Works</a>
            </div>
            <div className="p-4 link" onMouseOver={start}>
              <a href="#contactid">Contact</a>

              <ThreeDotsVertical className="pb-1" />

              <div className="pop_up p-2 ">
                <a href="#sendid">Say Hi</a>
                <a href="#contactid">Links</a>
                <a href="#donateid">Donate</a>
              </div>
            </div>
          </nav>
        </div>
        <div></div>
      </div>
      <main className="container p-5">
        <div className="row">
          <div className="col-lg-8">
            <h1>
              {" "}
              <span id="helloid">Hi</span> my name is Yizhak Farber
            </h1>
            <h3>I’m a full stack developer.</h3>
            <h4>
             I am a fast learner, Love to Learn new stuff, creative, intriguing, ambitious and tenacious and quickly learn new projects and technologies as you can see in my portfolio , in addition, in my personal life  I am volunteer in the organization to help the needy
            </h4>
          </div>

          <div className="col-lg-4  p-4">
            <div>
              <img id="yizimg" src="picyiz.jpeg" height="200" />
            </div>
            <hr />
            <div className="m-2 " data-tip="Tap to download ">
              Download
              <a href="YizCV.docx" target="_blank" rel="noopener noreferrer">
                <FaDownload id="fadwon" />
              </a>
              Resume
            </div>
          </div>
        </div>
      </main>

    </div>
  );
}

export default Headerstory;
